"use client";

import { FeatureHeroSection } from "@/components/shared/feature_hero_section";
import { AlternatingSection } from "@/components/shared/alternating_section";
import { DynamicEvents } from "@/components/shared/dynamic_events";
import { CustomButton } from "@/components/ui/custom-button";
import { get__related_how_we_help_pages } from "@/cms/how-we-help-data";

const LearnerInsights = () => {
    return (
        <main className="flex justify-center" role="main" aria-label="StudyStash Learner Insights Feature">
            <div className="flex w-full flex-col">
                {/* Hero Section */}
                <FeatureHeroSection
                    icon="/icon-pack/StudyStash - Icon - Cal.png"
                    iconAlt="Gamification Icon"
                    category="NSS Insights"
                    title="Improvements across"
                    highlightedText="metrics that matter"
                    description="When universities implement StudyStash, they see evidence-backed improvements across key performance indicators that drive institutional success."
                    buttonText="Join the pilot"
                    buttonHref="/pilot-program"
                    showDemoModal={true}
                    backgroundImage="/how-we-help/learner-insights/hero_learner_insights.png"
                    backgroundImageAlt="StudyStash Learner Insights Dashboard"
                    mobileImage="/how-we-help/learner-insights/hero_learner_insights.png"
                    mobileImageAlt="StudyStash Learner Insights Dashboard"
                />

                {/* Alternating Sections */}
                <div className="pt-24 md:pt-40 lg:pt-72">
                    <AlternatingSection 
                        sections={[
                            {
                                subtitle: "Early visibility, boost retention",
                                title: "Identify at-risk students before it's too late",
                                content: <>
                                    <p>StudyStash gives universities real-time visibility into where students are struggling, so support can be targeted where it matters most.</p>
                                    <p>By intervening early, institutions not only improve student outcomes but also protect retention - safeguarding both academic success and long-term revenue.</p>
                                </>,
                                image: {
                                    src: "/how-we-help/learner-insights/admin-dashboard.png",
                                    alt: "Demonstration of competitive features",
                                    width: 400,
                                    height: 400
                                }
                            },
                            {
                                subtitle: "Learner engagement hub",
                                title: "Institutional oversight built-in",
                                content: <>
                                    <p>With institutional oversight built-in, universities can move beyond end-of-module feedback. Our approach enables micro-surveys aligned with NSS themes to provide early indicators of performance, alongside pre/post evaluations on the data points that matter most to your institution.</p>
                                    <p>Measurable impact is important. That's why we suggest starting with our pilot program.</p>
                                    <div className="mt-6">
                                        <CustomButton
                                            variant="primary"
                                            size="lg"
                                            onClick={() => window.location.href = '/pilot-program'}
                                        >
                                           Read more about our pilot program
                                        </CustomButton>
                                    </div>
                                </>,
                                image: {
                                    src: "/how-we-help/learner-insights/insights_dashboard.png",
                                    alt: "Demonstration of gamification features",
                                    width: 400,
                                    height: 400
                                }
                            },
                            {
                                subtitle: "Insights for in-class teaching",
                                title: "See struggles, not just submissions",
                                content: <>
                                    <p>While students are studying, lecturers recieve weekly insights highlighting exactly which concepts cause difficulty across their cohort. This isn’t just data – it’s intelligence that improves teaching effectiveness without adding workload.</p>
                                </>,
                                image: {
                                    src: "/how-we-help/learner-insights/insights_email.png",
                                    alt: "Demonstration of progress tracking",
                                    width: 400,
                                    height: 400
                                }
                            },
                        ]}
                    />
                </div>

                {/* Related How We Help Pages */}
                <DynamicEvents 
                    items={get__related_how_we_help_pages("/how-we-help/learner-insights")}
                    showViewAll={false}
                    showKeepReading={true}
                />
            </div>
        </main>
    );
};

export default LearnerInsights;
